import React, {useRef} from 'react';
import {copyToClipBoard} from "../../dashboard/dataset-info-by-id/utils";
import {Toast} from "primereact/toast";

type CopyTextWithButtonProps = {
    text: string,
    copyableText?: string,
}

const CopyTextWithButton = ({text, copyableText}: CopyTextWithButtonProps) => {
    const myToast = useRef<Toast>(null);

    const onCopyClick = (text: string) => {
        copyToClipBoard(text).then(() => {
            myToast.current?.show({severity: 'success', summary: 'Copied to clipboard', detail: text, life: 3000});
        })
    }

    return <div className={"flex gap-1"}>
        <Toast ref={myToast} position={'bottom-right'}></Toast>
        <span>{text}</span>
        <i className={"pi pi-copy"}
           onClick={() => onCopyClick(copyableText || text)}
           style={{cursor: "pointer"}}
        ></i>
    </div>
};

export default CopyTextWithButton;